<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div
                    v-else
                    class="mb-4"
                >
                    <h4 class="text-secondary mb-2.5 font-bold">
                        請輸入欲提領之保單價值準備金
                    </h4>
                    <div class="border-style">
                        <div class="flex justify-between items-center max-width">
                            <label class="text-base xs:text-lg md:text-base text-gray-700 md:text-gray-400">目前保單價值準備金</label>
                            <div class="text-base xs:text-lg text-gray-700">
                                {{ addComma(userData) }}
                            </div>
                        </div>
                    </div>
                    <div class="border-style">
                        <div class="flex justify-between items-center max-width flex-wrap">
                            <label class="text-base xs:text-lg md:text-base text-gray-700 md:text-gray-400">本次欲提領</label>

                            <input
                                v-model.trim="withdraw"
                                inputmode="numeric"
                                autocomplete="off"
                                maxlength="7"
                                class="input-base w-[11rem] xs:w-[12.5rem] text-right"
                                placeholder="請輸入金額"
                                @input="validWithdraw(withdraw)"
                            >

                            <div class="flex justify-end w-full">
                                <p class="w-[11rem] xs:w-[12.5rem] error-msg text-right -mb-1 min-h-[0.25rem]">
                                    {{ errorMsg }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="border-style">
                        <ol class="list-decimal text-base text-gray-700 ml-6 space-y-2">
                            <li>提領之保單價值準備金不可低於{{ addComma(rateMin) }}元。</li>
                            <li>提領後剩餘之保單價值準備金不可低於{{ addComma(rateMax) }}元。</li>
                            <li>提領之保單價值準備金最高上限為新台幣100萬元。</li>
                            <li>減少保單價值準備金交易完成後之最高可借款金額若小於已借款本息時，將先行扣除超過之借款本息後給付。</li>
                        </ol>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="isGettingData"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getInfoAE, submitAE } from '@/apis/AE';
import { addComma } from '@/utils/number/addComma';
import { intMinMax } from '@/utils/rules/customRules';
import dialogContnet from '@/json/dialogContent';

import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Skeletons from './Skeletons.vue';
export default {
    components: {
        Bottombar,
        Loading,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const route = useRoute();
        const { code } = route.meta;
        const isLoading = ref(false);
        const isGettingData = ref(false);
        const isSubmitOk = ref(false);
        const userData = ref(0);
        const rateMin = ref(0);
        const rateMax = ref(0);
        const withdraw = ref(0);
        const errorMsg = ref('');
        const totalmax = 1000000;
        const result = computed(() => store.state.services.changeItemsResult[code]);

        // 取得api資料
        const getData = () => {
            isGettingData.value = true;
            getInfoAE().then(res => {
                // userData.value = 1000005;
                userData.value = res.data.valReserve;
                rateMin.value = res.data.downValReserveMin;
                rateMax.value = res.data.valReserveMin;
            }).finally(() => {
                isGettingData.value = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const { originData, userVal, min, max } = result.value;
            userData.value = originData;
            withdraw.value = userVal;
            rateMin.value = min;
            rateMax.value = max;
        }

        /** 驗證準備金 */
        const validWithdraw = (value) => {
            const { val, errorMessage } = intMinMax({
                value,
                minNum: rateMin.value,
                minMsg: `提領之保單價值準備金不可低於${addComma(rateMin.value)}元`,
                maxNum: userData.value - rateMax.value > totalmax ? totalmax : userData.value - rateMax.value,
                maxMsg: withdraw.value > userData.value ? '輸入的金額大於目前保單價值準備金' : withdraw.value > totalmax ? '提領之保單價值準備金最高上限為新台幣100萬元' : `提領後剩餘之保單價值準備金不可低於${addComma(rateMax.value)}元`,
                type: 2
            });
            errorMsg.value = errorMessage;
            withdraw.value = val;
        };
        const saveAndgoNext = () => {
            if (isGettingData.value) return;
            validWithdraw(withdraw.value);
            if (errorMsg.value) {
                modalShow(dialogContnet.validateMsg);
                return;
            }
            isLoading.value = true;
            submitAE(withdraw.value).then(res => {
                isSubmitOk.value = true;
                const value = {
                    originData: userData.value,
                    userVal: withdraw.value,
                    min: rateMin.value,
                    max: rateMax.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };
        return {
            isLoading,
            isGettingData,
            saveAndgoNext,
            isSubmitOk,
            userData,
            withdraw,
            addComma,
            rateMax,
            rateMin,
            errorMsg,
            validWithdraw
        };
    }
};
</script>
<style scoped lang="scss">
.max-width {
    @apply w-full sm:max-w-[30rem] md:max-w-[24rem];
}
.border-style {
    @apply border-t border-dashed border-gray-200 min-h-[3rem] md:min-h-[4.25rem] items-center flex py-2.5 md:py-3.5;
}
</style>
